import RegistrationSurvey from "./RegistrationSurvey";

export default RegistrationSurvey;
